import { Injectable } from '@angular/core';
import { first, map, shareReplay, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Cart } from '@app/models/cart';
import {
  IRenewalWarrantyInfo
} from '@app/shared-change-offer/renewal-warranty/change-offer-renewal-warranty.component';

@Injectable({
  providedIn: 'root'
})
export class ChangeOfferRenewalWarrantyService {
  constructor(private http: HttpClient) { }

  public getRenewalWarrantyInfo(cart: Cart, itemId: number): Observable<IRenewalWarrantyInfo> {
    return this.http
      .get('/api/order/cart/' + cart.setup.uuid + '/item/item_option?item_option_type=renewal_warranty')
      .pipe(first())
      .pipe(map((data) => {
        return data['data'][itemId]?.data
      }));
  }
}
